import GameOverModal from "./GameOverModal";
export default GameOverModal;
